<template>
  <v-app id="inspire">
    <router-view />
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      drawer: true
    }
  },
  //
}
</script>
